// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Besoin d'aide? \n Consultez notre documentation.`,
    documentation: `documentation`,
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  product: `produit`,
  invoice: `facture`,
  details: `détail`,
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `niveau menu`,
  menu_level_2a: `niveau menu 2a`,
  menu_level_2b: `niveau menu 2b`,
  menu_level_3a: `niveau menu 3a`,
  menu_level_3b: `niveau menu 3b`,
  menu_level_4a: `niveau menu 4a`,
  menu_level_4b: `niveau menu 4b`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  item_external_link: `lien externe de l'article`,
  description: `la description`,
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  wild: {
    animals_involved: 'Animaux impliqués',
    ai_insights: 'Analyses IA',
    dashboard: 'Tableau de bord',
    claims_manager: 'Gestionnaire de sinistres',
    reviewed_claims: 'Sinistres révisés',
    analyst_claims: 'Sinistres de l\'analyste',
    approved_claims: 'Sinistres approuvés',
    all_claims: 'Tous les sinistres',
    user_manager: 'Gestionnaire d\'utilisateurs',
    cvo_locator: 'Localisateur CVO',
    species_filters: 'Filtres d\'espèces',
    incident_details: 'Détails de l\'incident',
    view_full_claim: 'Voir le Sinistre Complet',
    ecological_analysis: 'Analyse écologique',
    real_time_insights: 'Analyses de la carte en temps réel',
    select_marker: 'Sélectionnez un marqueur pour voir les détails',
    generating: 'Génération en cours…',
    regenerate: 'Régénérer',
    generate_insights: 'Générer des analyses',
    click_generate: 'Cliquez sur Générer des analyses pour analyser les données actuelles avec l\'IA.',
    analysing: 'Analyse des données…',
    confidence_rating: 'Indice de confiance',
    ai_verification_score: 'Score de vérification IA',
    insight_history: 'Historique des analyses',
    previous_shared_reports: 'Rapports partagés précédents pour',
    // Analytics
    welcome_back: 'Bonjour, bon retour',
    total_claims: 'Total des sinistres',
    under_review: 'En cours de révision',
    pending_cvo: 'CVO en attente',
    pending_analysis: 'Analyse en attente',
    avg_review_time: 'Temps de révision moyen',
    paid_claims: 'Sinistres payés',
    paid_zmw: 'Payé (XAF)',
    pending_payment: 'Sinistres en attente de paiement',
    pending_payment_zmw: 'Paiement en attente (XAF)',
    claims_by_category: 'Sinistres par catégorie',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    gma_ward: 'Province/Département',
    rejected_claims: 'Sinistres rejetés',
    // Status
    status: {
      all: 'Tous',
      assigned: 'Assigné',
      acknowledged: 'Reconnu',
      travel: 'En déplacement',
      onsite: 'Sur place',
      checklist_submitted: 'Liste de contrôle soumise',
      initial_review: 'Révision initiale',
      approved: 'Approuvé',
      rejected: 'Rejeté',
      deferred: 'Reporté',
      complete: 'Terminé',
      payment_processing: 'Traitement du paiement',
      defer_analyst: 'Renvoyer à l’analyste',
      completed: 'Terminé',
      payment_failed: 'Échec du paiement',
      partially_paid: 'Partiellement payé',
    },
    // Table Headers
    table: {
      reference: 'Référence',
      nature_of_claim: 'Nature du sinistre',
      gma: 'Province',
      village: 'Village',
      claimant_names: 'Noms du demandeur',
      nrc_no: 'N° CNI du demandeur',
      date: 'Date',
      status: 'Statut actuel',
      assigned_cvo: 'CVO assigné',
      amount: 'Montant du sinistre (XAF)',
      claim_amount_zmw: 'Montant du sinistre (ZMW)',
      download_csv: 'Télécharger CSV',
      phone_no: 'Numéro de téléphone',
      actions: 'Actions',
      date_time: 'Date et heure',
      approved_amount: 'Montant approuvé',
      approver_comments: 'Commentaires de l’approbateur',
      payment_mode: 'Mode de paiement',
      account_name: 'Nom du titulaire du compte',
      account_number: 'Numéro de compte',
      transaction_amount_zmw: 'Montant de la transaction (ZMW)',
      amount_zmw: 'Montant (ZMW)',
      disbursement_note: 'Note de décaissement',
      name: 'Nom',
      email: 'E-mail',
      county: 'Comté',
      sub_county: 'Sous-comté',
      ward: 'Circonscription',
      role: 'Rôle',
      claimant_age: 'Âge du demandeur',
      claimant_gender: 'Sexe du demandeur',
    },
    // Interaction
    confirm_approve: 'Confirmer l\'approbation du sinistre',
    confirm_reject: 'Confirmer le rejet du sinistre',
    confirm_defer: 'Confirmer le report du sinistre',
    are_you_sure: 'Êtes-vous sûr de vouloir',
    view: 'Voir',
    edit_assign: 'Modifier/Assigner',
    delete: 'Supprimer',
    // Categories
    'Human death': 'Décès humain',
    'Crop damage': 'Dommages aux cultures',
    'Livestock predation': 'Prédation de bétail',
    'Property damage': 'Dommages aux biens',
    'Human injury': 'Blessure humaine',
    occurence_date: 'Date de l\'incident',
    task_name: 'Nom de la tâche',
    address: 'Adresse',
    cvo_note: 'Note du CVO',
    claimant_details: 'Détails du demandeur',
    ussd_phone: 'Numéro de téléphone USSD',
    assigned_to: 'Assigné à',
    next_of_kin: 'Proche parent',
    national_id: 'ID National',
    payment_details: 'Détails du paiement',
    analyst_status: 'Statut de l\'analyste',
    admin_status: 'Statut de l\'administrateur',
    verified: 'Vérifié',
    unverified: 'Non vérifié',
    'Task Checklist': 'Liste de contrôle de la tâche',
    nature_of_claim: 'Nature du sinistre',
    claimant_location: 'Emplacement du demandeur',
    claimant_age: 'Âge du demandeur',
    claimant_gender: 'Sexe du demandeur',
    extent_of_damage: 'Étendue des dommages',
    statement_claimant: 'Déclaration du demandeur',
    statement_witness: 'Déclaration du témoin',
    land_acreage: 'Superficie des terres',
    crop_destroyed: 'Culture détruite',
    approx_land_destroyed: 'Terrain approximatif détruit',
    growth_state: 'État de croissance',
    estimated_value_crops: 'Valeur estimée des récoltes',
    estimated_quantity_crops_per_acre: 'Quantité estimée de récoltes par acre',
    estimated_value_crop_per_acre: 'Valeur estimée des récoltes par acre',
    percentage_crop_loss: 'Pourcentage de perte de récolte',
    livestock_type: 'Type de bétail',
    number_dead: 'Nombre de têtes de bétail mortes',
    number_injured: 'Nombre de têtes de bétail blessées',
    estimated_value_loss: 'Valeur estimée de la perte',
    description_property: 'Description des biens endommagés',
    estimated_value_property: 'Valeur estimée des biens',
    description_predation_area: 'Description de la zone de prédation',
    animal_identification_details: 'Détails d’identification de l’animal',
    animal_age_sex_breed: 'Âge, sexe et race de l’animal',
    description_predation_occurrence: 'Description de l’incident de prédation',
    injured_surviving_animal_description: 'Description de l’animal blessé ou survivant',
    animal_health_condition: 'État de santé de l’animal',
    items_damaged: 'Objets endommagés',
    description_damage: 'Description des dommages',
    estimated_cost_repair: 'Coût estimé des réparations',
    maintenance_records: 'Registres d’entretien',
    ownership_evidence: 'Preuve de propriété',
    repair_quotes: 'Devis de réparation',
    cvo_findings: 'Constatations du CVO',
    cvo_recommendations: 'Recommandations du CVO',
    investigator_findings: 'Constatations de l’enquêteur',
    investigator_recommendations: 'Recommandations de l’enquêteur',
    investigator_amount_estimate: 'Montant estimé par l’enquêteur',
    appearance_injuries_description: 'Description de l’apparence des blessures',
    nature_injuries_description: 'Description de la nature des blessures',
    patient_under_advice_description: 'Description du suivi médical du patient',
    commencement_total_disability: 'Début de l’incapacité totale',
    mitigation_measure_in_place: 'Mesure d’atténuation en place',
    efficiency_mitigation: 'Efficacité de la mesure d’atténuation',
    date_incident: 'Date de l’incident',
    description_predator: 'Description du prédateur',
    chronology_events: 'Chronologie des événements',
    salvageable_items: 'Objets récupérables',
    gps_location_incident: 'Coordonnées GPS de l’incident',
    circumstance_injury_occurrence: 'Circonstances de l’accident',
    residence_address: 'Adresse du domicile',
    residence_post_code: 'Code postal du domicile',
    residence_assistant_chief: 'Chef adjoint du lieu de résidence',
    residence_location: 'Localité du domicile',
    residence_chief: 'Chef du lieu de résidence',
    residence_division: 'Division du domicile',
    employer_name: 'Nom de l’employeur',
    employer_nature_business: 'Activité de l’employeur',
    employer_salary: 'Salaire',
    injury_duration: 'Durée de la blessure',
    consultation_date: 'Date de consultation',
    percentage_incapacity: 'Pourcentage d’incapacité',
    police_ob_number: 'Numéro OB de la police',
    police_comments: 'Commentaires de la police',
    police_recommendations: 'Recommandations de la police',
    files: 'Fichiers',
    details: 'Détails',
    files_uploaded: 'Fichiers téléversés : {{count}}',
    add_files: 'Ajouter des fichiers',
    no_files_found: 'Aucun fichier trouvé',
    add_checklist_files: 'Ajouter des fichiers à la liste de contrôle',
    task_approved_successfully: 'Tâche approuvée avec succès !',
    task_approval_failed: 'Échec de l’approbation de la tâche.',
    task_deferred_successfully: 'Tâche reportée avec succès !',
    task_deferral_failed: 'Échec du report de la tâche.',
    task_rejected_successfully: 'Tâche rejetée avec succès !',
    task_rejection_failed: 'Échec du rejet de la tâche.',
    task_reviewed_successfully: 'Tâche examinée avec succès !',
    task_review_failed: 'Échec de l’examen de la tâche.',
    payment_initiated_successfully: 'Paiement lancé avec succès !',
    payment_initiation_failed: 'Échec du lancement du paiement.',
    task_completed_successfully: 'Tâche terminée avec succès !',
    task_completion_failed: 'Échec de la finalisation de la tâche.',
    process_payment: 'Traiter le paiement',
    approve_task: 'Approuver la tâche',
    reject_task: 'Rejeter la tâche',
    fraud_analysis_claim_estimator: 'Analyse de fraude et estimation du sinistre',
    standardized_payouts_discrepancies: 'Calcule les indemnisations normalisées et met en évidence les écarts',
    checklist_required_for_ai_analysis: 'Aucune donnée de liste de contrôle disponible. Une liste de contrôle doit être soumise pour effectuer l’analyse par IA.',
    standardized_crop_compensation: 'Indemnisation normalisée des dommages aux cultures',
    not_valid: 'Non valide',
    damaged_land: 'Superficie endommagée',
    photo_evidence: 'Preuves photographiques',
    calculation_basis: 'Base de calcul',
    minimum_claim: 'Indemnisation minimale',
    rate_per_damaged_hectare: '{{rate}} ZMW par hectare endommagé',
    task_status_timeline: 'Chronologie du statut de la tâche',
    status_change_timeline: 'Chronologie des changements de statut',
    confirm_initial_review: 'Confirmer l’examen initial de la tâche',
    defer: 'Reporter',
    submit_review: 'Soumettre l’examen',
    confirm_task_payment: 'Voulez-vous vraiment payer la tâche {{taskName}} ?',
    complete_task: 'Terminer la tâche',
    claims: 'Sinistres',
    all_users: 'Tous les utilisateurs',
    new_user: 'Nouvel utilisateur',
    approve: 'Approuver',
    approve_tasks: 'Approuver les tâches',
    process_payments: 'Traiter les paiements',
    confirm_tasks_payment_processing: 'Confirmer le traitement des paiements des tâches',
    tasks_updated_successfully: 'Tâches mises à jour avec succès !',
    tasks_update_failed: 'Échec de la mise à jour des tâches.',
    confirm_delete_items: 'Voulez-vous vraiment supprimer {{count}} élément(s) ?',
    confirm_approve_task_name: 'Voulez-vous vraiment approuver la tâche {{taskName}} ?',
    confirm_reject_task_name: 'Voulez-vous vraiment rejeter la tâche {{taskName}} ?',
    confirm_selected_tasks_payment: 'Voulez-vous vraiment payer les tâches sélectionnées ?',
    update_payment_status_for: 'Mettre à jour le statut de paiement de : {{taskName}}',
    user_delete_success: 'Utilisateur supprimé avec succès !',
    deletion_failed: 'Échec de la suppression.',
    confirm_delete_user: 'Voulez-vous vraiment supprimer {{firstName}} {{lastName}} ?',
    reset_password: 'Réinitialiser le mot de passe',
    search: 'Rechercher…',
    clear: 'Effacer',
    update_payment: 'Mettre à jour le paiement',
    domestic_animal: 'Animal domestique',
    dead_livestock: 'Bétail mort',
    injured_livestock: 'Bétail blessé',
  },
};

export default fr;
